import { api_GET, api_POST, api_DELETE } from "api/axios.js";

const guiadestinacao_api =
{
    getList: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_POST(`guiadestinacao/List`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getItemFromFicha: function(localId, mapaentradaId){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`guiadestinacao/${localId}/${mapaentradaId}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    relatorio: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_POST(`guiadestinacao/relatorio`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    }, 
    post: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_POST(`guiadestinacao`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    delete: function(id){
        const promise = new Promise((resolve, reject) => { 
            api_DELETE(`guiadestinacao`, id).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
}

export default guiadestinacao_api
